import { all } from 'redux-saga/effects';

import { fillOrderSaga } from './order/sagas';
import { saveServicesSaga, watchExternalActionsSaga } from './selectedServices/sagas';
import { exchangeSaga } from '@entities/exchange';
import { refundSagas } from '@entities/refund';
import { subsidiesSaga } from './subsidies/sagas';

export default function* rootSaga() {
	yield all([
		fillOrderSaga(),
		saveServicesSaga(),
		watchExternalActionsSaga(),
		exchangeSaga(),
		refundSagas(),
		subsidiesSaga()
	]);
}
